<template>
	<div>
		<el-dialog v-for="(dialog,index) in dialogs" :key="dialog.time" :width="dialog.options.width||'85vw'"
			:visible="true" @close="close(dialog,index)" :title="dialog.options.title">
			<template v-if="dialog.component=='Pre'">
				<div class="relative oa">
					<pre v-html="dialog.options.content"></pre>
				</div>
			</template>
			<template v-else>
				<component :is="dialog.component" v-bind="dialog.options" @close="close(dialog,index)"
					@success="success(dialog,index)" @select="select(dialog,index,$event)">
				</component>
			</template>
		</el-dialog>
	</div>
</template>
<script>
	import AdminTable from '@/components/AdminTable'
	import AdminForm from '@/components/AdminForm'

	import RoleTable from '@/components/RoleTable'
	import RoleForm from '@/components/RoleForm'
	import RobotTable from '@/components/RobotTable'
	import RobotForm from '@/components/RobotForm'
	import LlmTable from '@/components/LlmTable'
	import LlmForm from '@/components/LlmForm'

	import Chart from '@/components/Chart'
	import AudioPlayer from '@/components/AudioPlayer'



	export default {
		components: {

			AdminTable,
			AdminForm,

			RoleTable,
			RoleForm,
			RobotTable,
			RobotForm,
			LlmTable,
			LlmForm,

			Chart,

			AudioPlayer,
		},
		data() {
			return {
				dialogs: [],
			}
		},
		methods: {
			open(component, options) {
				this.dialogs.push({
					component,
					options,
					time: Date.now(),

				})
			},
			close(dialog, index) {
				this.dialogs.splice(index, 1);
			},
			success(dialog, index) {
				dialog.options.success && dialog.options.success();
				this.close(dialog, index);
			},
			select(dialog, index, row) {
				console.log(row)
				dialog.options.select && dialog.options.select(row);
				this.close(dialog, index);
			}

		}
	}
</script>

<style>
</style>